
import { defineComponent, ref } from "vue-demi";
import type { TPricingItem } from "@/models/pricing";
import { isIncludedInPackage } from "@/constants/subscription"

export default defineComponent({
  name: "ServicesBlock",

  props: {
    pricingItem: {
      type: Object as () => TPricingItem | null,
      default: null,
    },
  },

  emits: ["click"],

  setup(_, {emit}) {
    const selectedTabIndex = ref(0);

    function onClick(to: string) {
      emit("click", to);
    }

    return {
      selectedTabIndex,
      onClick,
      isIncludedInPackage
    };
  },
});
